<template>
  <div class="content-item mb16">
    <cx-check-box :value.sync="showAutoLayoutVal">开启自动布局模式</cx-check-box>
    <div v-if="showAutoLayoutVal" class="setting-item clearFloat mt16">
      <div class="content-item clearFloat verticallyCenter arrange-sets">
        <div>
          <div class="verticallyCenter mb16">
            <span class="mr16 fs14">方向</span>
            <div class="autoLayout-directions">
              <span
                @click="directionVal = 'vertical'"
                :class="directionVal === 'vertical' ? 'active' : ''"
                class="icon-portal-direction-down"
              ></span>
              <span
                @click="directionVal = 'horizon'"
                :class="directionVal !== 'vertical' ? 'active' : ''"
                class="icon-portal-direction-right"
              ></span>
            </div>
          </div>
          <div class="verticallyCenter">
            <span class="mr16 fs14">间距</span>
            <single-input
              placeholder="0"
              class="mr16"
              style="width: 88px; margin-right: 0"
              :value.sync="marginBottomVal"
              inputSuffixs="px"
            />
<!--            <el-input-->
<!--              placeholder="0"-->
<!--              class="mr16"-->
<!--              type="number"-->
<!--              style="width: 88px; margin-right: 0"-->
<!--              v-inputHandle="{ this1, type: 'marginBottomVal' }"-->
<!--              v-model="marginBottomVal"-->
<!--            >-->
<!--              <template slot="suffix">-->
<!--                <span class="suffix_text">px</span>-->
<!--              </template>-->
<!--            </el-input>-->
          </div>
        </div>
        <div class="align-style-box">
          <div v-if="directionVal === 'vertical'">
            <div class="align-style-item" v-for="(position, index) in positions.vertical" :key="'position_' + index">
              <el-tooltip
                class="item"
                effect="dark"
                v-for="(item, hIndex) in alignStyles"
                :key="hIndex"
                :content="position.label + item.label + '对齐'"
                placement="top-end"
                :open-delay="1000"
              >
                <span
                  class="align-style"
                  @mouseenter.self.stop="alignStyleMouseenter(position.value, hIndex)"
                  @mouseleave.self.stop="alignStyleMouseleave"
                  :class="[
                    alignStyleHover && hoverAlignPosition === position.value && hIndex === hoverAlignIndex
                      ? 'active icon ' + item.icon
                      : 'default',
                    alignPositionHVal === item.positionH && alignPositionVVal === position.value
                      ? 'selected icon ' + item.icon
                      : ''
                  ]"
                  @click="changeAlignStyle(item.positionH, position.value)"
                ></span>
              </el-tooltip>
            </div>
          </div>
          <div v-if="directionVal === 'horizon'">
            <div class="align-style-item" v-for="(item, index) in alignStyles" :key="'position_' + index">
              <el-tooltip
                class="item"
                effect="dark"
                v-for="(position, hIndex) in positions.horizon"
                :key="hIndex"
                :content="item.label + position.label + '对齐'"
                placement="top-end"
                :open-delay="1000"
              >
                <span
                  class="align-style"
                  @mouseenter.self.stop="alignStyleMouseenter(position.value, index)"
                  @mouseleave.self.stop="alignStyleMouseleave"
                  :class="[
                    alignStyleHover && hoverAlignPosition === position.value && index === hoverAlignIndex
                      ? 'active icon ' + item.icon
                      : 'default',
                    alignPositionHVal === position.value && alignPositionVVal === item.positionV
                      ? 'selected icon ' + item.icon
                      : ''
                  ]"
                  @click="changeAlignStyle(position.value, item.positionV)"
                ></span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    },
    elementOptions: {
      type: Array
    }
  },
  data() {
    return {
      this1: this,
      positions: {
        horizon: [
          {
            value: "left",
            label: "左"
          },
          {
            value: "center",
            label: "居中"
          },
          {
            value: "right",
            label: "右"
          }
        ],
        vertical: [
          {
            value: "top",
            label: "顶部"
          },
          {
            value: "middle",
            label: ""
          },
          {
            value: "bottom",
            label: "底部"
          }
        ]
      },
      alignStyleHover: false,
      hoverAlignPosition: null,
      hoverAlignIndex: null,
      verticalAlignStyles: [
        {
          label: "左",
          icon: "icon-portal-h-left",
          positionH: "left"
        },
        {
          label: "居中",
          icon: "icon-portal-h-center",
          positionH: "center"
        },
        {
          label: "右",
          icon: "icon-portal-h-right",
          positionH: "right"
        }
      ],
      horizonAlignStyles: [
        {
          label: "顶部",
          icon: "icon-portal-v-top",
          positionV: "top"
        },
        {
          label: "",
          icon: "icon-portal-v-middle",
          positionV: "middle"
        },
        {
          label: "底部",
          icon: "icon-portal-v-bottom",
          positionV: "bottom"
        }
      ]
    }
  },
  computed: {
    showAutoLayoutVal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "showAutoLayout", "showAutoLayout", false)
      },
      set(newVal) {
        this.$emit("update", "showAutoLayout", newVal)
      }
    },
    directionVal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "direction", "direction", "vertical")
      },
      set(newVal) {
        if (newVal === this.directionVal) return
        this.$emit("update", "direction", newVal)
      }
    },
    marginBottomVal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "marginBottom", "marginBottom", 0)
      },
      set(newVal) {
        if (newVal === this.marginBottomVal) return
        this.$emit("update", "marginBottom", newVal)
      }
    },
    alignPositionHVal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "alignPositionH", "alignPositionH", "left")
      },
      set(newVal) {
        if (newVal === this.alignPositionH) return
        this.$emit("update", "alignPositionH", newVal)
      }
    },
    alignPositionVVal: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "alignPositionV", "alignPositionV", "top")
      },
      set(newVal) {
        if (newVal === this.alignPositionV) return
        this.$emit("update", "alignPositionV", newVal)
      }
    },
    alignStyles() {
      return this.directionVal === "vertical" ? this.verticalAlignStyles : this.horizonAlignStyles
    },
    elementOptionsVal: {
      get() {
        return this.elementOptions || []
      },
      set(newVal) {
        this.$emit("update", "elementOptions", newVal)
      }
    }
  },
  methods: {
    alignStyleMouseenter(poition, index) {
      this.alignStyleHover = true
      this.hoverAlignPosition = poition
      this.hoverAlignIndex = index
    },
    alignStyleMouseleave() {
      this.alignStyleHover = false
      this.hoverAlignPosition = null
      this.hoverAlignIndex = null
    },
    changeAlignStyle(positionH, positionV) {
      this.alignPositionHVal = positionH
      this.alignPositionVVal = positionV
    },
    // 重新计算组件的位置
    reComputePosition(val) {
      if (val) {
        this.elementOptionsVal.forEach((item, index) => {
          this.$set(item, "isNoConflictCheck", true)
        })
        return
      }
      let col = document.getElementById(`componentBox_after${this.ids.uid}`)
      let autoLayoutBox = col.getElementsByClassName("auto-layout-container")[0]
      let elements = autoLayoutBox.getElementsByClassName("vdr")
      let top = autoLayoutBox.offsetTop,
        left = autoLayoutBox.offsetLeft
      if (this.alignPositionVVal === "middle") {
        top = col.clientHeight / 2 - autoLayoutBox.clientHeight / 2
      }
      if (this.alignPositionHVal === "center") {
        left = col.clientWidth / 2 - autoLayoutBox.clientWidth / 2
      }
      this.elementOptionsVal.forEach((item, index) => {
        let itemTop = elements[index].offsetTop + top
        let itemLeft = elements[index].offsetLeft + left
        delete item.isNoConflictCheck
        this.$set(item, "top", itemTop)
        this.$set(item, "left", itemLeft)
      })
    }
  }
}
</script>
<style scoped>
.arrange-sets {
  justify-content: space-between;
}
.autoLayout-directions {
  background-color: var(--inputBackGround);
  border-radius: 3px;
  padding: 2px;
  color: var(--iconColor);
}
.autoLayout-directions span {
  display: inline-block;
  line-height: 28px;
  width: 42px;
  text-align: center;
  cursor: pointer;
}
.autoLayout-directions span.active {
  color: #fff;
  background-color: var(--themeColor);
  border-radius: 3px;
}
.align-style-box {
  width: 80px;
  height: 80px;
  padding: 6px;
  box-sizing: border-box;
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  background-color: var(--leftMenuBgColor);
}
.align-style {
  position: relative;
  display: inline-block;
  cursor: pointer;
  font-size: 20px;
}
.align-style.icon:hover:before {
  color: var(--themeColorDisabled);
}
.align-style.icon.selected:before {
  color: var(--themeColor);
}
.align-style.default:not(.selected):before {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 2px;
  content: "";
  background-color: var(--iconColor);
  transform: translate(-50%, -50%);
}
.align-style-item {
  display: flex;
  justify-content: space-around;
}
.align-style-item span {
  display: inline-block;
  line-height: 20px;
  height: 20px;
  width: 20px;
}
</style>
